export const OPERATOR_ID_ROUTE_PARAM = 'operatorId';
export const STRUCTURE_ID_ROUTE_PARAM = 'structureId';
export const FORM_ID_ROUTE_PARAM = 'formId';
export const PROTOCOL_ID_ROUTE_PARAM = 'protocolId';
export const INFO_ID_ROUTE_PARAM = 'infoId';
export const USER_ID_ROUTE_PARAM = 'userId';
